var mixin = {
    props: {
        modelValue: {
            type: Object,
            default: () => ({}),
        },
        index: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            component: { ...this.modelValue },
        };
    },
    methods: {
        update(field, value) {
            this.component[field] = value;
        },
    },
    watch: {
        component: {
            handler(component) {
                this.$emit("update:modelValue", component);
            },
            deep: true,
        },
    },
};

export default mixin;
